import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {
    createInstructorPlanDialog
} from '../../admin/school-settings/change-instructor-plan-dialog/change-instructor-plan-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {TenantService} from '../../services/tenant.service';
import {calculateTrialDaysLeft, isTrialExpired} from '../../common/trial-utils';

import {TenantInfo} from '../../models/tenant.model';
import {concatMap, tap} from 'rxjs/operators';
import {LoadingService} from '../services/loading.service';
import {InstructorPlanService} from '../../admin/school-settings/instructor-plan.service';
import {isTrialWithoutCardActive} from '../../common/ui-constants';
import { loadStripeJs } from "../utils/stripe-loader";

@Component({
    selector: 'trial-expiration',
    templateUrl: './trial-expiration.component.html',
    styleUrls: ['./trial-expiration.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialExpirationComponent implements OnInit {
    private dialog = inject(MatDialog);
    private loading = inject(LoadingService);
    private instructorPlanService = inject(InstructorPlanService);
    private tenantService = inject(TenantService);


    tenant: TenantInfo;
    daysLeft: number;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {

    }

    ngOnInit() {
        this.tenant = this.tenantService.tenant;
        this.daysLeft = calculateTrialDaysLeft(this.tenant);

    }


    onUpgradeClicked() {
        createInstructorPlanDialog(this.dialog)
            .pipe(
                concatMap(plan => this.loading.showLoaderUntilCompleted(
                        this.instructorPlanService.updateInstructorPlan(
                            false,
                            this.tenant['email'],
                            plan?.selectedInstructorPlanId,
                            plan?.selectedPlanFrequency
                        )
                    )
                ),
                tap(async (response) => {
                    const StripeConstructor = await loadStripeJs();
                    const stripe = StripeConstructor(response.stripePublicKey);

                    stripe.redirectToCheckout({
                        sessionId: response.sessionId
                    });
                })
            )
            .subscribe();

    }

    displayUpgradeOption() {
        return this.tenant?.instructorPricingPlan == 'growth' &&
          !isTrialExpired(this.tenant) &&
          isTrialWithoutCardActive();
    }

}
